import React from 'react'

export default function SkeletonTabla() {
    return (
        <div role="status" className="w-full animate-pulse divide-y divide-gray-200 rounded border border-gray-200 p-2 shadow">
            <div className="flex items-center justify-between space-x-4 bg-gray-400 px-3 h-[35px]">
            <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <div className="flex items-center justify-between space-x-4 px-3 py-3">
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="h-3.5 w-24 rounded-lg bg-gray-300 "></div>
                <div className="flex flex-row space-x-2">
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                    <div className="h-6 w-6 rounded-full bg-gray-300 "></div>
                </div>
            </div>
            <span className="sr-only">Loading...</span>
        </div>

    )
}
